import client from '@/apis/http-client'
import Vue from 'vue'
import qs from 'qs'

const useMockData = false
const resource = 'executives'

const mockSource = [
  {
    id: 'exe-1',
    name_th: 'นพ. สมชาย ใจดี',
    name_en: 'Dr. Somchai Jaidee',
    position_th: 'ผู้อำนวยการโรงพยาบาล',
    position_en: 'Hospital Director',
    photo_url: 'https://obs.example.com/executives/e1.png',
    executive_type: 'executive_management',
    display_order: 1,
    updated_at: '2026-09-30T09:00:00Z'
  }
]

const defaultState = () => ({
  currentPage: 1,
  pageSize: 10,
  total: 0,
  sortBy: 'display_order',
  sortDesc: 'ASC',
  textSearch: '',
  filterType: '',
  list: [],
  isLoading: false,
  isSaving: false
})

const state = defaultState()
const generateMockId = (prefix) => `${prefix}-${Date.now()}-${Math.floor(Math.random() * 100000)}`

const actions = {
  async upload(_, payload) {
    try {
      const response = await client.secureHttpClient.post('/por/api/upload/obs', payload)
      return response?.data?.url || response?.data?.data?.url || ''
    } catch (e) {
      Vue.$log.error(e)
      return ''
    }
  },
  setResource() {},
  resetList({commit}) { commit('RESET_LIST_STATE') },
  setTextSearch({commit}, text) { commit('SET_TEXT_SEARCH', text) },
  setFilterType({commit}, type) { commit('SET_FILTER_TYPE', type) },
  async fetch({commit, state}) {
    commit('SET_IS_LOADING', true)

    if (useMockData) {
      let data = [...mockSource]
      if (state.textSearch) {
        const term = state.textSearch.toLowerCase()
        data = data.filter(item => `${item.name_th || ''} ${item.name_en || ''} ${item.position_th || ''} ${item.position_en || ''}`.toLowerCase().includes(term))
      }
      if (state.filterType) {
        data = data.filter(item => item.executive_type === state.filterType)
      }
      commit('SET_LIST', data)
      commit('SET_TOTAL', data.length)
      commit('SET_IS_LOADING', false)
      return
    }

    try {
      const response = await client.secureHttpClient.get(`/por/api/${resource}`, {
        params: {
          page: state.currentPage,
          limit: state.pageSize,
          orderBy: state.sortBy,
          sort: state.sortDesc,
          search: state.textSearch,
          type: state.filterType
        },
        paramsSerializer: localParams => qs.stringify(localParams, {encode: false})
      })
      const resData = response?.data || {}
      const list = resData.results || resData.data || []
      const total = resData.total !== undefined ? resData.total : list.length
      commit('SET_LIST', Array.isArray(list) ? list : [])
      commit('SET_TOTAL', total)
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_LIST', [])
      commit('SET_TOTAL', 0)
    }

    commit('SET_IS_LOADING', false)
  },
  async save({commit}, payload) {
    commit('SET_IS_SAVING', true)
    if (useMockData) {
      if (payload.id) {
        const index = mockSource.findIndex(item => item.id === payload.id)
        if (index !== -1) mockSource[index] = {...mockSource[index], ...payload, updated_at: new Date().toISOString()}
      } else {
        mockSource.unshift({...payload, id: generateMockId('exe'), updated_at: new Date().toISOString()})
      }
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    }

    try {
      if (payload.id) await client.secureHttpClient.put(`/por/api/${resource}/${payload.id}`, payload)
      else await client.secureHttpClient.post(`/por/api/${resource}`, payload)
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_SAVING', false)
      return {ok: false, message: e?.response?.data?.message || 'Unable to save'}
    }
  },
  async deleteById(_context, id) {
    if (useMockData) {
      const index = mockSource.findIndex(item => item.id === id)
      if (index !== -1) mockSource.splice(index, 1)
      return true
    }
    try {
      await client.secureHttpClient.delete(`/por/api/${resource}/${id}`)
      return true
    } catch (e) {
      Vue.$log.error(e)
      return false
    }
  }
}

const mutations = {
  RESET_LIST_STATE(state) {
    state.currentPage = 1
    state.pageSize = 10
    state.total = 0
    state.sortBy = 'display_order'
    state.sortDesc = 'ASC'
    state.textSearch = ''
    state.filterType = ''
    state.list = []
  },
  SET_TEXT_SEARCH(state, text) { state.textSearch = text },
  SET_FILTER_TYPE(state, type) { state.filterType = type },
  SET_LIST(state, list) { state.list = list },
  SET_TOTAL(state, total) { state.total = total },
  SET_IS_LOADING(state, isLoading) { state.isLoading = isLoading },
  SET_IS_SAVING(state, isSaving) { state.isSaving = isSaving }
}

export default { namespaced: true, state, actions, mutations }
